var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_1590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66748 8.95312H24.4408",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.708 13.6465V20.6865",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4019 13.6465V20.6865",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8418 8.95312L8.01513 23.0331C8.01513 23.6555 8.26237 24.2524 8.70245 24.6925C9.14254 25.1326 9.73942 25.3798 10.3618 25.3798H19.7485C20.3708 25.3798 20.9677 25.1326 21.4078 24.6925C21.8479 24.2524 22.0951 23.6555 22.0951 23.0331L23.2685 8.95312",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5347 8.9531V5.4331C11.5347 5.12191 11.6583 4.82347 11.8783 4.60343C12.0984 4.38338 12.3968 4.25977 12.708 4.25977H17.4013C17.7125 4.25977 18.011 4.38338 18.231 4.60343C18.451 4.82347 18.5747 5.12191 18.5747 5.4331V8.9531",
    stroke: "black",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_1590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.16,
    height: 28.16,
    fill: "white",
    transform: "translate(0.974609 0.740234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteicon);
export default __webpack_public_path__ + "static/media/deleteicon.751aadbac86d611ee4f40f018b2f91ac.svg";
export { ForwardRef as ReactComponent };